import React from 'react';
import { ConnectedUserContext } from '../../connectedUser-context';

import SeasonAdmin_gen from './SeasonAdmin_gen';
import SeasonAdmin_subs from './SeasonAdmin_subs';
import SeasonAdmin_eqcfg from './SeasonAdmin_eqcfg';
import SeasonAdmin_qvneaSummary from './SeasonAdmin_qvneaSummary';

class SeasonAdmin_nav extends React.Component {

  static contextType = ConnectedUserContext;

  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'gen',
    };
  }

  renderTabContent() {
    const { activeTab } = this.state;
    const { season } = this.props;

    switch (activeTab) {
      case 'gen':
        return <SeasonAdmin_gen season={season} />;
      case 'subs':
        return <SeasonAdmin_subs season={season} reloadSeason={this.props.reloadSeason} />;
      case 'eqcfg':
        return <SeasonAdmin_eqcfg season={season} />;
      case 'qvneaSummary':
        return <SeasonAdmin_qvneaSummary season={season} />;
      default:
        return null;
    }
  }

  render() {
    const { activeTab } = this.state;
    const { season } = this.props;
    const { connectedUser } = this.context;

    //if (connectedUser.isSeasonAdmin) {
      return (
        <div>
          <h5><b>Saison:&nbsp;&nbsp;</b>{season.name}</h5>

          <div className="row">
            <div className="col-md-12">
              <button
                className={`btn btn-primary btnlink-green ${activeTab === 'gen' ? 'active' : ''}`}
                onClick={() => this.setState({ activeTab: 'gen' })}
              >
                Paramètres généraux
              </button>&nbsp;&nbsp;&nbsp;&nbsp;

              <button
                className={`btn btn-primary btnlink-green ${activeTab === 'subs' ? 'active' : ''}`}
                onClick={() => this.setState({ activeTab: 'subs' })}
              >
                Sous-saisons et Divisions
              </button>&nbsp;&nbsp;&nbsp;&nbsp;

              <button
                className={`btn btn-primary btnlink-green ${activeTab === 'eqcfg' ? 'active' : ''}`}
                onClick={() => this.setState({ activeTab: 'eqcfg' })}
              >
                Équipes et substituts
              </button>&nbsp;&nbsp;&nbsp;&nbsp;

              { connectedUser.isQvneaMaster && (
                <button
                  className={`btn btn-qvnea ${activeTab === 'qvneaSummary' ? 'active' : ''}`}
                  onClick={() => this.setState({ activeTab: 'qvneaSummary' })}
                >
                  QVNEA Sommaire
                </button>
              )}
            </div>
          </div>

          <br />
          {this.renderTabContent()}
        </div>
      );
    //}

    return null;
  }
}

export default SeasonAdmin_nav;
